import { Response } from 'miragejs';

import LocalStorageManager from 'mocks/server/localStorageManager';
import {
  IBaseEntity,
  IDraftEntity,
  ILiveEntity,
  ILiveFrame,
  ILiveLinkedAsset,
} from 'types/detailsEntityType';
import { DraftStatus, LiveStatus } from 'utils/statuses';

export const populateDraftsStore = (
  generatedDraftEntities: IDraftEntity[],
  removedEntities: LocalStorageManager<IBaseEntity>,
  draftEntityStore: LocalStorageManager<IDraftEntity>
) => {
  generatedDraftEntities.forEach((draftEntity) => {
    if (
      removedEntities
        .getAll()
        .some((removedEntity) => removedEntity.spaceId === draftEntity.spaceId)
    ) {
      return;
    }
    if (!draftEntityStore.getById(draftEntity.spaceId)) {
      draftEntityStore.add(draftEntity);
    }
  });
};

export const populateLiveEntityStore = (
  generatedEntities: ILiveEntity[],
  liveEntityStore: LocalStorageManager<ILiveEntity>
) => {
  generatedEntities.forEach((entity) => {
    if (!liveEntityStore.getById(entity.spaceId)) {
      liveEntityStore.add(entity);
    }
  });
};

export const setStatusForEntities = (
  spaceIds: string[],
  store: LocalStorageManager<ILiveEntity | IDraftEntity>,
  status: LiveStatus | DraftStatus
) => {
  spaceIds.forEach((spaceId: string) => {
    store.update(spaceId, { status: status });
  });
};

export const handleSetStatus = (
  data: string,
  failedFrameId: Array<string>,
  failedFrameIdNoDraft: Array<string>,
  action: string,
  store: LocalStorageManager<ILiveFrame | ILiveLinkedAsset>,
  status: LiveStatus | DraftStatus
) => {
  const spaceIds = JSON.parse(data);

  setStatusForEntities(spaceIds, store, status);
  console.log(`Successful ${action} for IDs: ${spaceIds}`);

  const spaceIdsWithDraft: string[] = [];
  const spaceIdsWithoutDraft: string[] = [];

  spaceIds.forEach((id: string) => {
    if (failedFrameId.includes(id)) {
      spaceIdsWithDraft.push(id);
    }

    if (failedFrameIdNoDraft.includes(id)) {
      spaceIdsWithoutDraft.push(id);
    }
  });

  const responseBody = {
    totalItemsActioned: spaceIds.length,
    spaceIdsWithDraft,
    spaceIdsWithoutDraft,
  };

  return new Response(200, {}, responseBody);
};

export const getDraftEntities = (
  draftFrameStore: LocalStorageManager<IDraftEntity>,
  draftLinkedAssetStore: LocalStorageManager<IDraftEntity>,
  status: DraftStatus
) => {
  const draftFrames = draftFrameStore.getAll();
  const draftLinkedAssets = draftLinkedAssetStore.getAll();
  const drafts = draftFrames.concat(draftLinkedAssets);

  return drafts
    .filter((element) => element.status === status)
    .map((draftEntity) => {
      return {
        spaceId: draftEntity.spaceId,
        name: draftEntity.name,
        environment: draftEntity.environment,
        formatSize: draftEntity.formatSize ? draftEntity.formatSize.name : null,
        entityType: draftEntity.entityType,
        status: draftEntity.status,
      };
    });
};

export const removeEntities = (
  spaceIds: string[],
  store: LocalStorageManager<IBaseEntity>,
  removedEntities: LocalStorageManager<IBaseEntity>
) => {
  spaceIds.forEach((spaceId: string) => {
    const byId = store.getById(spaceId);
    store.remove(spaceId);
    if (byId) {
      removedEntities.add(byId);
    }
  });
};
